import { Wrapper } from '@frontend/design_system'
import { useEffect, useRef } from 'react'
import styles from './styles.module.scss'
import { DATA_LAYER_EVENT } from 'constants/dataLayerEvents'
import { GTM } from 'utils/gtm'
import { GeneralNotification } from 'ui/molecules/GeneralNotification'
import { HowItWorks } from 'modules/Join/components/HowItWorks'
import { JoinBlock } from 'modules/Join/components/JoinBlock'
import { BecomePartnerForm } from 'modules/Join/components/JoinForm'
import { Footer } from 'ui/components/Footer'
import { Header } from 'ui/components/Header'

export const Join = () => {
  const formRef = useRef<HTMLDivElement>(null)

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }

  useEffect(() => {
    GTM.dataLayer({
      event: DATA_LAYER_EVENT.PAGE_VIEW,
      page_location: window.location.href,
      pageTitle: 'Join our marketplace',
    })
  }, [])

  return (
    <>
      <Header />
      <Wrapper className={styles.layout}>
        <div className={styles.notification}>
          <GeneralNotification top={80} right="16px" />
        </div>
        <JoinBlock onClick={scrollToForm} />
        <HowItWorks />
        <BecomePartnerForm ref={formRef} />
      </Wrapper>
      <Footer />
    </>
  )
}
